import SupportScreen from '@rahtab/system/lib/screens/SupportScreen';
import React from 'react';
import { version } from '../../../package.json';

const Support = () => <SupportScreen version={version} />;

export default Support;
